/**
 * Created by Tormi Talv <tormi.talv@ambientia.ee> on 2016-04-27 10:57.
 */

require('../bootstrap');

let Inputmask = require('inputmask');

Inputmask({'mask': '99:99:99'}).mask(document.getElementsByClassName('time'));
Inputmask({'mask': '[9]9[.99]', 'placeholder': ' '}).mask(document.getElementsByClassName('distance'));

$('.quickdistances a').click(function () {
  var $targetInputId = $(this).closest('.quickdistances').data('input-id');
  $('#' + $targetInputId).val($(this).text());
});

$('#calculateResults').click(function () {
  var knownResult = $('#knownResult').val();
  var knownDistance = $('#knownDistance').val() * 1000;
  var newDistance = $('#newDistance').val() * 1000;
  var prognosedResult = 0;

  if (knownResult && knownDistance && newDistance) {

    $('#resultDistance').text(newDistance / 1000 + ' km');

    knownResult = knownResult.split(':');
    knownResult = (+knownResult[0]) * 60 * 60 + (+knownResult[1]) * 60 + (+knownResult[2]);

    // T1 on teada oleva võistluse aeg
    // D1 tolle võistluse distants
    // D2 võistluse distants, mille kohta tahetakse aega leida
    // T2 prognoositav tulemus

    //Riegeli valem
    //T2=T1(D2/D1)^1,06

    prognosedResult = knownResult * Math.pow((newDistance / knownDistance), 1.06);

    $('#resultRiegelPrognosed').text(secondsToHMS(prognosedResult));
    $('#resultRiegelTempo').text(secondsToHMS(prognosedResult / (newDistance / 1000)));

    //Cameroni valem
    //T₂ = T₁⋅[D₂/D₁]⋅[f(D₁)/f(D₂)]
    //f(x) =13.49681 - 0.000030363x + 835.7114/x^0.7905

    var f1 = 13.49681 - (0.000030363 * knownDistance) + (835.7114 / (Math.pow(knownDistance, 0.7905)));
    var f2 = 13.49681 - (0.000030363 * newDistance) + (835.7114 / (Math.pow(newDistance, 0.7905)));

    prognosedResult = knownResult * (newDistance / knownDistance) * (f1 / f2);

    $('#resultCameronPrognosed').text(secondsToHMS(prognosedResult));
    $('#resultCameronTempo').text(secondsToHMS(prognosedResult / (newDistance / 1000)));

    //Marathon100 valem

    if ((knownDistance <= 21100 && knownDistance >= 21000) && (newDistance <= 42200 && newDistance >= 42000)) {

      var avg = knownResult / (knownDistance / 1000);
      var prognosedSpeed = 0;

      if (avg >= 256) {
        prognosedSpeed = avg * (1.073 + (avg - 256) * 0.001);
      } else if (avg >= 215) {
        prognosedSpeed = avg * (1.073 - (256 - avg) * 0.0006);
      } else {
        prognosedSpeed = avg * 1.049;
      }

      $('#resultMarathonPrognosed').text(secondsToHMS(prognosedSpeed * (newDistance / 1000)));
      $('#resultMarathonTempo').text(secondsToHMS(prognosedSpeed));

    } else {

      $('#resultMarathonPrognosed').text('-');
      $('#resultMarathonTempo').text('-');

    }

  }
});

function secondsToHMS(s) {
  var h = Math.floor(s / 3600);
  s -= h * 3600;
  var m = Math.floor(s / 60);
  s -= m * 60;
  s = Math.floor(s);
  return h + ':' + (m < 10 ? '0' + m : m) + ':' + (s < 10 ? '0' + s : s);
}